<template>
  <div class="review-draft">
    <div v-show="loading" class="loading">
      <img src="../assets/loading.gif"/>
    </div>
    <div class="detail">
      <p class="detail-title">下書き内容</p>
      <p class="p__style__4">
        {{ content }}
      </p>
    </div>
    <div class="item-area">
      <div v-for="(item, index) in resouces" :key="index" class="item">
        <img
          :src="item.url"
          alt="アップロード写真"
          @click="previewPhoto(item.url)"
          v-if="item.type == 'image'"
        />
        <video
          :src="item.url"
          alt="アップロード動画"
          controls
          v-else
        ></video>
      </div>
    </div>
    <div class="button-area">
      <common-button
        :data="{
          status: 0,
          button: `戻る`,
        }"
        style="max-width: 317px"
        @click="back()"
      ></common-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import CommonButton from "./CommonButton.vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();
const loading = ref(false);

const content = ref("");
const resouces = ref<{ url: string; resource_order: number, type: string }[]>([]);

onMounted(() => {
  const list = JSON.parse(String(route.query.resouces)) || [];
  if (Array.isArray(list) && list.length)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
    list.forEach((v: any) => {
      resouces.value.push(v);
    });
  content.value = String(route.query.content);
});

function back() {
  router.back();
}

function previewPhoto(url: string) {
  window.open(url);
}
</script>
<style lang="scss" scoped>
@import "../assets/style/_variables.scss";
@import "../assets/style/mixin.scss";

@mixin p__defalut($size, $line_height) {
  font-style: normal;
  font-weight: 300;
  font-size: $size;
  line-height: $line_height;
  color: #333333;
  margin: 0;
  white-space: pre-line;
}

.review-draft {
  width: 100%;
  max-width: 480px;
  height: 100%;
  max-height: 810px;
  overflow-y: auto;
  scrollbar-gutter: stable;
}
.item-area {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 480px;
  width: 100%;
  padding-bottom: 300px;
}
.item {
  width: 350px;
  height: 350px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background-color: $white;
  }
  padding-right: 8px;
  padding-left: 8px;
  padding-bottom: 30px;
}
.header {
  text-align: center;
  width: 100%;
  padding-top: 10px;
}
.detail {
  margin-top: 49px;
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
  background: #fbfbfb;
  border-radius: 5px;
  margin-right: 20px;
  margin-left: 20px;
  padding-bottom: 15px;
  .detail-title {
    margin-bottom: 0;
    padding-left: 15px;
    // font-family: $font-family-hiragino-gothic-pron;
    font-style: normal;
    font-weight: 600;
    font-size: $FONT_SIZE_M;
    line-height: 21px;
  }
  p {
    margin-left: 15px;
    padding-right: 15px;
    padding-bottom: 13px;
    padding-left: 13px;
    padding-top: 10px;
    margin-right: 15px;
    word-break: break-all;
  }
}
.p__style__4 {
  @include p__defalut($FONT_SIZE_M, 21px);
}

label {
  font-size: $FONT_SIZE_M;
}
.title {
  margin-top: 40px;
  text-align: center;
  font-style: normal;
  font-weight: 600;
  font-size: $FONT_SIZE_L;
  line-height: 24px;
  height: 60px;
  width: 100%;
  max-width: 480px;
  background-color: rgba(8, 110, 182, 0.04);
  > p {
    margin: 0;
    padding-top: 18px;
  }
}
.button-area {
  width: 100%;
  max-width: 480px;
  height: 56px;
  margin: 0 auto;
  text-align: center;
  position: fixed;
  bottom: 80px;
  font-size: $FONT_SIZE_M;
  line-height: 21px;
}
.loading {
  margin: 0 auto;
  width: 50px;
  height: 50px;
}

.first-loading {
  display: flex;
  width: 96%;
  max-width: 460px;
  position: fixed;
  justify-content: center;
  top: 50%;
  img {
    width: 10%;
    height: 10%;
  }
}
</style>
